import React from 'react';
import { string, bool } from 'prop-types';
import styled from 'styled-components';
import SmoothButton from './SmoothOrangeButton';

const Header = styled.header`
  height: ${({ marketing }) => (marketing ? '361px' : '316px')};
  background: ${({ image }) => (image.includes('-mkt')
    ? `url(${process.env.PUBLIC_URL}/images/${image}.png) center no-repeat;`
    : `linear-gradient(rgba(0,0,0,.2), rgba(0,0,0,.2)), url(${process.env.PUBLIC_URL}/images/${image}.jpg) center no-repeat;`)};
  background-size: cover;
  display: flex;
  flex-direction: column;
  ${({ marketing }) => marketing && 'justify-content: flex-end;'};
  align-items: center;
  border-bottom: 4px solid #f6f6f6;

  @media(max-width: 999px) {
    ${({ marketing }) => marketing && 'height: 246px'};
    ${({ marketing, image }) => (marketing
    ? 'background: #F28000;'
    : `background: linear-gradient(rgba(0,0,0,.2), rgba(0,0,0,.2)), url(${process.env.PUBLIC_URL}/images/${image}.jpg) center no-repeat;`)};
    ${({ marketing }) => marketing && 'justify-content: flex-start;'};
  }
`;

const TitleBox = styled.div`
  margin: ${({ marketing }) => (marketing ? '64px 24px 38px 24px' : '64px 24px 48px 24px')};

  @media(min-width: 1000px) {
    margin: ${({ marketing }) => (marketing ? '64px 24px 18px 24px' : '64px 0px 48px 0px')};
    ${({ marketing }) => marketing && 'width: 637px'};
  }
`;

const Title = styled.h1`
  color: #ffffff;
  display: ${({ marketing }) => (marketing ? 'block' : 'inline-block')};
  font-family: 'Nunito Sans', sans-serif;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  text-shadow: 0 0 32px rgba(0, 0, 0, 0.2);

  @media(min-width: 1000px) {
    font-size: 36px;
  }
`;

const Subtitle = styled.h2`
  color: #ffffff;
  font-family: 'Nunito Sans', sans-serif;
  font-size: ${({ marketing }) => (marketing ? '24px' : '20px')};
  text-align: center;
  text-shadow: 0 0 32px rgba(0, 0, 0, 0.2);
  margin-top: 16px;
  font-weight: ${({ marketing }) => (marketing ? 'bold' : 'normal')};

  @media(min-width: 1000px) {
    font-size: ${({ marketing }) => (marketing ? '36px' : '24px')};
  }
`;

const LandingHeader = ({
  image, title, subtitle, marketing,
}) =>
  (
    <Header image={image} marketing={marketing}>
      <TitleBox marketing={marketing}>
        <Title marketing={marketing}>{title}</Title>
        <Subtitle marketing={marketing}>{subtitle}</Subtitle>
      </TitleBox>
      <SmoothButton type="white" to="plans" marketing>Conheça os Planos</SmoothButton>
    </Header >
  );


LandingHeader.propTypes = {
  image: string.isRequired,
  title: string.isRequired,
  subtitle: string,
  marketing: bool,
};

LandingHeader.defaultProps = {
  marketing: false,
  subtitle: null,
};

export default LandingHeader;
